import * as Sentry from '@sentry/svelte';

const apiUrl = import.meta.env.VITE_ADMIN_API_URL;
const adminVersion = import.meta.env.VITE_FULL_VERSION;

const checkVersion = async () => {
  try {
    const response = await fetch(`${apiUrl}/api/version`);
    const { version: apiVersion } = await response.json();

    if (apiVersion && apiVersion !== adminVersion) {
      window.location.reload();
    }
  } catch (e) {
    Sentry.captureException(e);
  }
};

export const initializeVersionCheck = () => {
  window.fullVersion = adminVersion;
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkVersion();
    }
  });
};
